export function matchesNavigationPath(pathname: string, href: string): boolean {
  if (href === "/") {
    return pathname === href;
  }

  return pathname === href || pathname.startsWith(`${href}/`);
}

export function isNavLinkActive(pathname: string, href: string): boolean {
  return matchesNavigationPath(pathname, href);
}

export type NavItemLike = {
  href: string;
  items?: NavItemLike[];
};

export function isNavItemOrChildActive(
  pathname: string,
  item: NavItemLike,
): boolean {
  return (
    isNavLinkActive(pathname, item.href) ||
    Boolean(
      item.items?.some((child) => isNavItemOrChildActive(pathname, child)),
    )
  );
}
